import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import PageShell from '@/components/PageShell';
import SEO from '@/components/SEO';
import { useLanguage } from '@/i18n/LanguageContext';
import { CITIES } from '@/data/cityContent';
import { track } from '@/lib/analytics';

const ServiceAreasIndex = () => {
  const { lang, t } = useLanguage();
  return (
    <PageShell trackPage="/areas">
      <SEO title="Service Areas | Amigo's Bail Bonds | Montgomery County, TX" description="Amigo's Bail Bonds serves Conroe, The Woodlands, New Caney, Montgomery, Willis, Magnolia, Splendora, Livingston and Cold Spring." path="/areas" />
      <div className="page-hero">
        <div className="eyebrow">{lang === 'es' ? 'ÁREAS DE SERVICIO' : 'SERVICE AREAS'}</div>
        <h1 className="section-title">{lang === 'es' ? 'DÓNDE TRABAJAMOS' : 'WHERE WE WORK'}</h1>
        <p className="section-subtitle" style={{ margin: '0 auto' }}>{lang === 'es' ? 'El Condado de Montgomery y comunidades vecinas.' : 'Montgomery County and neighboring communities.'}</p>
      </div>
      <section className="section section--void">
        <div className="container">
          <div className="card-grid card-grid--3">
            {CITIES.map((c) => (
              <Link to={`/areas/${c.slug}`} className="city-card" key={c.slug} onClick={() => track('service_area_view', { city: c.slug, from: 'areas_index' })} data-testid={`areas-index-card-${c.slug}`}>
                <div className="city-card__county"><MapPin size={12} style={{ verticalAlign: 'middle', marginRight: 4 }} />{c[lang].county}</div>
                <div className="city-card__name">{c[lang].name}</div>
                <span className="city-card__arrow">{t('common.learnMore')} &rarr;</span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </PageShell>
  );
};

export default ServiceAreasIndex;
